import React from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import ReactDOM from 'react-dom';

import { App } from './App';
import './index.css';
import './polyfills';
import { initSentryInBrowser } from './sentry';

initSentryInBrowser();

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root'),
);
